import { Component, GondelBaseComponent, EventListener } from '@gondel/core';

/**
 * search module implementation.
 * @author Danijel Malinovic <danijel.malinovic@merkleinc.com>
 */

enum Breakpoints {
	Md = 670,
}

enum Selectors {
	OpenSearchButton = '.js-m-search__button-open',
	CloseSearchButton = '.js-m-search__button-close',
	ClearSearchButton = '.js-m-search__button-clear',
	SearchButton = '.js-m-search__button',
	Overlay = '.m-search__overlay',
	Input = '.js-m-search__input',
}
enum States {
	Open = 'm-search__overlay--open',
	SearchOpened = 'state-o-header__search__overlay--open',
}

enum CustomDataAttributes {
	SearchUrl = 'data-search-url',
}

@Component('Search')
export class Search extends GondelBaseComponent {
	private _searchInput: HTMLInputElement = {} as HTMLInputElement;
	private _header: HTMLElement = {} as HTMLElement;

	public start() {
		this._header = document.querySelector('header') as HTMLBodyElement;
		this._searchInput = this._ctx.querySelector(Selectors.Input) as HTMLInputElement;
		window.addEventListener('scroll', () => {
			this._closeSearch();
		});

		window.addEventListener('click', ({ target }: MouseEvent) => {
			const targetNode: Node = target as Node;
			if (targetNode && !this._ctx.contains(targetNode)) {
				this._closeSearch();
			}
		});
	}

	@EventListener('keyup', Selectors.Input)
	public _onKeyPress(event: KeyboardEvent): void {
		if (event.key === 'Enter') {
			this._onSearch();
		}
	}

	@EventListener('keydown')
	public _onKeyDown(event: KeyboardEvent): void {
		if (event.key === 'Escape') {
			this._closeSearch();
		}
	}

	@EventListener('click', Selectors.SearchButton)
	private _onSearch(): void {
		const searchUrl: string = this._ctx.getAttribute(CustomDataAttributes.SearchUrl) as string;
		window.open(window.location.origin.concat(searchUrl, '?search=', this._searchInput?.value), '_self');
	}

	@EventListener('click', Selectors.OpenSearchButton)
	@EventListener('keyup.enter', Selectors.OpenSearchButton)
	private _openSearch(): void {
		this._header.classList.add(States.SearchOpened);
		const overlay = this._getElement(Selectors.Overlay);
		overlay?.classList.add(States.Open);
		// eslint-disable-next-line @typescript-eslint/no-unused-expressions
		this._ctx.offsetWidth; // Reflow to make transition work
		this._searchInput?.focus();
	}

	@EventListener('click', Selectors.CloseSearchButton)
	@EventListener('keyup.enter', Selectors.CloseSearchButton)
	private _closeSearch(): void {
		this._header.classList.remove(States.SearchOpened);
		const overlay = this._getElement(Selectors.Overlay);
		overlay?.classList.remove(States.Open);
		if (window.innerWidth < Breakpoints.Md) {
			this._searchInput.value = '';
		}
	}

	@EventListener('click', Selectors.ClearSearchButton)
	@EventListener('keyup.enter', Selectors.ClearSearchButton)
	private _clearSearch(): void {
		this._searchInput.value = '';
	}

	private _getElement(selector: string) {
		return this._ctx.querySelector(selector);
	}
}
